<template>
    <div :class="['state', type]">
        <slot />
    </div>
</template>

<script>
export default {
  name: "vBadge",
  props: {
    type: {
      type: String,
      required: true,
    }
  },
}
</script>

<style scoped lang="sass">
    .state
        color: white
        font-size: $base-font-size
        border: none
        border-radius: 6px
        padding: gridSteps(1) gridSteps(1)
        margin: gridSteps(0.5) 0 0 gridSteps(2)
        display: inline-block
        vertical-align: top

    .light
        background: #e7ebee
        color: #2d2d2d

    .primary
        background: #487bb9

    .danger
        background: #a94442

    .success
        background: darkgreen

</style>
